/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { catalogosServiceState, getCatalogoEstatusCluni, getCatalogoFiguraLegal, getCatalogoTipoInstitucion, getCatalogoTipoPoblacion } from "../../slices/catalogosServiceSlice";
import { appState, setAlert, setLoading } from "../../slices/appSlice";
import InputComp from "../generales/inputComponent";
import { fillForm, formatForm, validateForm } from "../../app/commons";
import { changeStep, updateEmpresaSeleccionada } from "../../slices/registroSlice";
import { changeStep as changeStepConv } from "../../slices/registroConvocatoriaSlice";
import { putEntidad } from "../../services/entidad";
import { ALERT_FAIL, ALERT_SUCCESS, DATOS_CONTACTO_STEP, DATOS_PARTICIPACION_STEP, INFORMACION_GENERAL_STEP, SERVICIO_ADICIONALES_STEP } from "../../app/constantes";
import { InformacionOscForm, siNoCatalogo } from "../../app/forms/registro/informacion-osc";
import moment from "moment";

export default function InformacionOsc({empresaSeleccionada, isSede, isConvocatoria}) {
    const dispatch = useDispatch();
    const catalogosSt = useSelector(catalogosServiceState);
    const appSt = useSelector(appState);

    const [form, setForm] = useState(JSON.parse(JSON.stringify(InformacionOscForm)));

    /**
     * Paso anterior
     */
    const prevStep = () => {
        if (isConvocatoria) {
            dispatch(changeStepConv(DATOS_PARTICIPACION_STEP))
        } else {
            dispatch(changeStep(INFORMACION_GENERAL_STEP));
        }
    }

    const nextStep = () => {
        if (isConvocatoria) {
            dispatch(changeStepConv(SERVICIO_ADICIONALES_STEP))
        } else {
            handleSubmit()
        }
    }

    /**
     * Guardar info
     */
    const handleSubmit = async () => {
        const valid = validateForm(form);

        if (valid.length === 0) {
            // dispatch(setLoading(true));
            const formatedForm = formatForm(form);
            formatedForm.fechaPublicacion = formatedForm.isDonataria === "1" ? formatedForm.fechaPublicacion : null
            formatedForm.cluni = formatedForm.isCluni === "1" ? formatedForm.cluni : null
            formatedForm.idCatEstatusCluni = formatedForm.isCluni === "1" ? formatedForm.idCatEstatusCluni : null
            delete formatedForm.isCluni
            delete formatedForm.isDonataria
            const body = {
                ...formatedForm,
                idEntidad: empresaSeleccionada.idEntidad 
            }
            const resp = await putEntidad({
                ...appSt.serviceData, 
                idEntidad: empresaSeleccionada.idEntidad
            }, body);
            if (resp.payload) {
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: 'Datos Guardados',
                    type: ALERT_SUCCESS
                }));
                const updateData = {
                    ...appSt.serviceData,
                    idEntidad: empresaSeleccionada.idEntidad
                }
                dispatch(updateEmpresaSeleccionada(updateData));
                dispatch(changeStep(DATOS_CONTACTO_STEP));
            } else {
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: 'Error al guardar información',
                    type: ALERT_FAIL
                }))
            }
        } else {
            dispatch(setAlert({
                show: true,
                message: 'Favor de llenar los campos obligatorios',
                type: ALERT_FAIL
            }))
        }
    }

    useEffect(() => {
        
    }, [empresaSeleccionada])

    useEffect(() => {
        let clone = JSON.parse(JSON.stringify(form))

        if (form.isDonataria.value === "0") {
            clone.fechaPublicacion.value = ""
            clone.fechaPublicacion.required = false
            clone.fechaPublicacion.invalid = false
        }

        if (form.isDonataria.value === "1") {
            clone.fechaPublicacion.value = 
                empresaSeleccionada && empresaSeleccionada.fechaPublicacion 
                    ? moment(empresaSeleccionada.fechaPublicacion).format("YYYY-MM-DD") : form.fechaPublicacion.value ? form.fechaPublicacion.value : ""
            clone.fechaPublicacion.required = true
            clone.fechaPublicacion.invalid = false
        }
        if (form.isCluni.value === "0") {
            clone.cluni.value = ""
            clone.cluni.required = false
            clone.cluni.invalid = false
            clone.idCatEstatusCluni.value = ""
            clone.idCatEstatusCluni.required = false
            clone.idCatEstatusCluni.invalid = false
        }
    
        if (form.isCluni.value === "1") {
            clone.cluni.value = empresaSeleccionada && empresaSeleccionada.cluni ? empresaSeleccionada.cluni : ""
            clone.cluni.required = true
            clone.cluni.invalid = false
            clone.idCatEstatusCluni.value = empresaSeleccionada && empresaSeleccionada.idCatEstatusCluni ? empresaSeleccionada.idCatEstatusCluni : ""
            clone.idCatEstatusCluni.required = true
            clone.idCatEstatusCluni.invalid = false
        }
        
        setForm(clone)
        
    }, [form.isDonataria.value, form.isCluni.value])
    
    useEffect(() => {
        let clone = JSON.parse(JSON.stringify(form))

        if (empresaSeleccionada) {
            clone = fillForm(clone, empresaSeleccionada)
            clone.fechaPublicacion.value = moment(empresaSeleccionada.fechaPublicacion).format("YYYY-MM-DD")
            clone.isDonataria.value = empresaSeleccionada.fechaPublicacion ? "1" : "0"
            clone.isCluni.value = empresaSeleccionada.cluni ? "1" : "0"
            setForm(clone)
        } else {
            setForm(clone)
        }


    }, [empresaSeleccionada])

    /**
     * obtenemos catalogos
     */
    useEffect(() => {
        if (!catalogosSt.tipoInstitucion) {
            dispatch(getCatalogoTipoInstitucion(appSt.serviceData));
        }
        if (!catalogosSt.figuraLegal) {
            dispatch(getCatalogoFiguraLegal(appSt.serviceData));
        }
        if (!catalogosSt.estatusCluni) {
            dispatch(getCatalogoEstatusCluni(appSt.serviceData));
        }
        if (!catalogosSt.tipoPoblacion) {
            dispatch(getCatalogoTipoPoblacion(appSt.serviceData));
        }
    }, []);

    return (
        <div className="registro-step redes">
            <div className="content">
                {catalogosSt.figuraLegal && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label="Figura legal" 
                        name="idFiguraLegal" 
                        type="select"
                        catalogos={catalogosSt.figuraLegal}
                        catalogoLabel={"descFiguraLegal"} 
                        catalogoValue={"idFiguraLegal"}
                        form={form} 
                        setForm={setForm} />
                )}
                {catalogosSt.tipoInstitucion && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label="Tipo de institución" 
                        name="idTipoInstitucion" 
                        type="select"
                        catalogos={catalogosSt.tipoInstitucion}
                        catalogoLabel={"descTipoInstitucion"} 
                        catalogoValue={"idTipoInstitucion"}
                        form={form} 
                        setForm={setForm} />
                )}
                <InputComp 
                    disabled={isSede || isConvocatoria} 
                    label={"¿Eres donataria autorizada por el SAT?"} 
                    name={"isDonataria"} 
                    catalogos={siNoCatalogo}
                    catalogoLabel={"label"} 
                    catalogoValue={"value"}
                    form={form}
                    setForm={setForm}
                    type={"select"} />
                {form.isDonataria.value === "1" && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label={"Fecha de última publicación"} 
                        name={"fechaPublicacion"} 
                        form={form}
                        setForm={setForm}
                        type={"date"} />
                )}
                {<p>{form.fechaPublicacion.value}</p>}
                 <InputComp 
                    disabled={isSede || isConvocatoria} 
                    label={"¿Cuentas con CLUNI?"} 
                    name={"isCluni"} 
                    catalogos={siNoCatalogo}
                    catalogoLabel={"label"} 
                    catalogoValue={"value"}
                    form={form}
                    setForm={setForm}
                    type={"select"} />
                {form.isCluni.value === "1" && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label={"CLUNI"} 
                        name={"cluni"} 
                        form={form}
                        setForm={setForm}
                        type={"upper"} />
                )}
                {catalogosSt.estatusCluni && form.isCluni.value === "1" && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label="Estatus CLUNI" 
                        name="idCatEstatusCluni" 
                        type="select"
                        catalogos={catalogosSt.estatusCluni}
                        catalogoLabel={"descEstatusCluni"} 
                        catalogoValue={"idCatEstatusCluni"}
                        form={form} 
                        setForm={setForm} />
                )}
                {catalogosSt.tipoPoblacion && (
                    <InputComp 
                        disabled={isSede || isConvocatoria} 
                        label="Tipo de población" 
                        name="idTipoPoblacion" 
                        type="select"
                        catalogos={catalogosSt.tipoPoblacion}
                        catalogoLabel={"descTipoPoblacion"} 
                        catalogoValue={"idTipoPoblacion"}
                        form={form} 
                        setForm={setForm} />
                )}
            </div>


            <div className="actions">
                <button onClick={prevStep}>Regresar</button>
                <button onClick={nextStep}>Continuar</button>
            </div>
        </div>
    )
}